export default __webpack_public_path__ + "static/media/new-interior.16586851.jpg";